module.exports = __webpack_public_path__ + "img/thumbnail_AsianSmallClawedOtter_f_albino.400e034c.png";